module.exports = __webpack_public_path__ + "img/d3550_1295_310_area_a2.ffcacb80.jpg";